import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// CODE PROMO : discret tant qu'on n'en a pas (un lien), la remise vient TOUJOURS du serveur. Partage entre l'ecran « Produit »
// (avant la commande) et le recapitulatif de paiement d'une commande en attente (2026-11-03 : l'ecran « Produit » ne se rouvre plus
// une fois la commande creee — un client revenu payer plus tard ne pouvait plus saisir son code).
// `editable` faux : la remise deja appliquee s'affiche, sans champ ni « Retirer ».
function PromoCodeField({
  promo = null,
  promoInput = '',
  onPromoInput = () => {},
  onApplyPromo = () => {},
  onRemovePromo = () => {},
  promoStatus = { state: 'idle', reason: '' },
  formatPrix,
  editable = true,
  busy = false
}) {
  const [ouvert, setOuvert] = useState(false);
  const { t } = useTranslation('checkout');

  if (promo) {
    return (
      <div className="orders-promo orders-promo-applied" role="status">
        <span>{t('stepProduct.promo.applied', { code: promo.code, percent: promo.percentOff, amount: formatPrix(promo.discountCents) })}</span>
        {editable && <button type="button" className="orders-promo-link" onClick={onRemovePromo} disabled={busy}>{t('stepProduct.promo.remove')}</button>}
      </div>
    );
  }
  if (!editable) return null;
  return (
    <div className="orders-promo">
      {!ouvert && promoStatus.state !== 'invalid' ? (
        <button type="button" className="orders-promo-link" onClick={() => setOuvert(true)}>{t('stepProduct.promo.have')}</button>
      ) : (
        <form
          className="orders-promo-form"
          onSubmit={(event) => { event.preventDefault(); onApplyPromo(); }}
        >
          <label htmlFor="orders-promo-input">{t('stepProduct.promo.label')}</label>
          <input
            id="orders-promo-input"
            className="input-luxe"
            value={promoInput}
            maxLength={24}
            autoComplete="off"
            autoCapitalize="characters"
            spellCheck={false}
            onChange={(event) => onPromoInput(event.target.value)}
          />
          <button type="submit" className="btn btn-outline" disabled={busy || !promoInput.trim() || promoStatus.state === 'checking'}>
            {promoStatus.state === 'checking' ? t('stepProduct.promo.checking') : t('stepProduct.promo.apply')}
          </button>
        </form>
      )}
      {promoStatus.state === 'invalid' && (
        <p className="orders-promo-error" role="alert">
          {promoStatus.reason === 'too_many' ? t('stepProduct.promo.tooMany') : t('stepProduct.promo.invalid')}
        </p>
      )}
    </div>
  );
}

export default PromoCodeField;
